import Vue from "vue";

export default {
  getDepartments({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(state.filterValue != "" && { status: state.filterValue }),
      };

      Vue.$http
        .get("/organization/departments", { params })
        .then(response => {
          commit("departments", response.data.results);
          commit("totalEmployees", response.data.total);
          commit("tableLoader", false);

          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getDepartmentById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/departments/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getAllDepartments() {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/departments`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getAllBranches({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/branches")
        .then(response => {
          // backend now always wraps the branch list as { results, total }
          const branches = response.data.results || response.data;
          commit("branches", branches);
          resolve(branches);
          commit("tableLoader", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoader", false);
        });
    });
  },

  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getDepartments");
  },

  handleCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getDepartments");
  },

  getStationDepartments({ commit }, branch_id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/branches/${branch_id}/departments`)
        .then(response => {
          commit("stationDepartments", response.data);
          resolve(response);
          commit("tableLoader", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoader", false);
        });
    });
  },

  createDepartment({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/organization/departments`, params)
        .then(response => {
          resolve(response);
          commit("tableLoader", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoader", false);
        });
    });
  },

  updateDepartment({ commit }, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/organization/departments/${params.id}`, params)
        .then(response => {
          resolve(response);
          commit("tableLoader", false);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoader", false);
        });
    });
  },

  deleteDepartment({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/organization/departments/delete`, { departmentIds: id })
        .then(response => {
          resolve(response);
          commit("tableLoader", false);
        })
        .catch(error => {
          reject(error);
          commit("tableLoader", false);
        });
    });
  },

  getEmployees({ commit }, search_query) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        search_query,
      };

      Vue.$http
        .get("/organization/employees", { params })
        .then(response => {
          commit("employees", response.data.results);
          commit("totalEmployees", response.data.total);
          commit("tableLoader", false);

          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
};
